/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { TenantRequest, TenantRequestStatus } from "../../../models/tenant-request"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { REQUEST_ENDPOINT } from "../request.endpoint"

const requestQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getRequest: builder.query<TenantRequest, string>({
      query: (id: string) => ({
        url: `${REQUEST_ENDPOINT.detail}/${id}?includes[]=tenant&includes[]=unit&includes[]=unit.property`,
        method: "get",
      }),
      providesTags: ["Request"],
    }),

    getRequests: builder.query<Collection<TenantRequest>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${REQUEST_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Requests"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownerCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countRequests: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${REQUEST_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Requests"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownerCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedRequest: builder.query<TenantRequest, string>({
      query: (id: string) => ({
        url: `${REQUEST_ENDPOINT.archivedRequest}/${id}`,
        method: "get",
      }),
    }),

    getArchivedRequests: builder.query<
      Collection<TenantRequest>,
      CollectionQuery
    >({
      query: (data: CollectionQuery) => ({
        url: `${REQUEST_ENDPOINT.archivedRequests}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedOwnerCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    assignRequest: builder.mutation<any, { id: string; maintenanceId: string }>(
      {
        query: (data: { id: string; maintenanceId: string }) => ({
          url: `${REQUEST_ENDPOINT.assignRequest}/${data.id}/${data.maintenanceId}`,
          method: "post",
        }),
        invalidatesTags: ["Request", "Requests"],
      },
    ),

    createRequest: builder.mutation<TenantRequest, FormData>({
      query: (newData: FormData) => ({
        url: `${REQUEST_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateRequest: builder.mutation<TenantRequest, FormData>({
      query: (newData: FormData) => ({
        url: `${REQUEST_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getRequests",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((user) => {
            //           if (user.id === data.id) return data
            //           else {
            //             return user
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    changeRequestStatus: builder.mutation<TenantRequest, {id: string; status: TenantRequestStatus}>({
      query: (data: {id: string; status: TenantRequestStatus}) => ({
        url: `${REQUEST_ENDPOINT.changeRequestStatus}/${data.id}/${data.status}`,
        method: "post",
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getRequests",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((user) => {
            //           if (user.id === data.id) return data
            //           else {
            //             return user
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    // updateUserProfile: builder.mutation<User, any>({
    //   query: (newData: any) => ({
    //     url: `${REQUEST_ENDPOINT.updateProfile}` + newData.id,
    //     method: "post",
    //     data: newData.data,
    //   }),

    //   async onQueryStarted(param, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled;
    //       if (data) {
    //         notification("success", "Successfully updated");
    //         dispatch(
    //           requestQuery.util.updateQueryData(
    //             "getRequests",
    //             ownerCollection,
    //             (draft) => {
    //               if (data) {
    //                 draft.data = draft?.data?.map((user) => {
    //                   if (user.id === data.id) return data;
    //                   else {
    //                     return user;
    //                   }
    //                 });
    //               }
    //             }
    //           )
    //         );
    //       }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message
    //           ? error?.error?.data?.message
    //           : "Error try again"
    //       );
    //     }
    //   },
    // }),

    toggleRequestStatus: builder.mutation<TenantRequest, string>({
      query: (id: string) => ({
        url: `${REQUEST_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Request", "Count Requests"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getRequests",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((owner: Owner) => {
            //           if (owner.id === data.id) return data
            //           else {
            //             return owner
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   requestQuery.util.updateQueryData("getRequest", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveRequest: builder.mutation<
      TenantRequest,
      { id: string; reason: string }
    >({
      query: (data) => ({
        url: `${REQUEST_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getRequests",
            //     ownerCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === arg.id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   requestQuery.util.updateQueryData("getRequest", arg?.id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getArchivedOwner",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteRequest: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${REQUEST_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getArchivedRequests",
            //     archivedOwnerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((user) => user.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreRequest: builder.mutation<TenantRequest, string>({
      query: (id: string) => ({
        url: `${REQUEST_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-requests",
      }),
      invalidatesTags: ["Requests", "Count Requests"],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getRequests",
            //     ownerCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   requestQuery.util.updateQueryData("getRequest", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   requestQuery.util.updateQueryData(
            //     "getArchivedOwner",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    removeRequestFile: builder.mutation<
      TenantRequest,
      { requestId: string; filename: string }
    >({
      query: (data: { requestId: string; filename: string }) => ({
        url: `${REQUEST_ENDPOINT.removeFile}/${data.requestId}/${data.filename}`,
        method: "post",
        permission: "manage-requests",
      }),
      invalidatesTags: ["Request", "Requests"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   leaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (rentIncrease) => rentIncrease.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyGetArchivedRequestQuery,
  useLazyGetRequestQuery,
  useLazyCountRequestsQuery,
  useLazyGetRequestsQuery,
  useLazyGetArchivedRequestsQuery,

  useCreateRequestMutation,
  useUpdateRequestMutation,
  useDeleteRequestMutation,
  useArchiveRequestMutation,
  useRestoreRequestMutation,
  useToggleRequestStatusMutation,
  useAssignRequestMutation,
  useRemoveRequestFileMutation,
  useChangeRequestStatusMutation
} = requestQuery
